import React from 'react';
import { FileText, Trash2, RotateCw } from 'lucide-react';

/**
 * Saved Drafts panel (R13). Lists server-side drafts of a given type with
 * Resume + Delete buttons. The form NEVER auto-loads a draft — the user
 * must click Resume.
 */
export const DraftsPanel = ({ drafts, onResume, onDelete, currentDraftId, title = 'Saved Drafts' }) => {
  if (!drafts || drafts.length === 0) return null;
  const fmtTime = (iso) => {
    if (!iso) return '';
    try {
      const d = new Date(iso);
      return d.toLocaleString(undefined, { month: 'short', day: 'numeric', hour: 'numeric', minute: '2-digit' });
    } catch {
      return '';
    }
  };
  return (
    <div className="bg-amber-50 border border-amber-200 rounded-lg p-4" data-testid="drafts-panel">
      <div className="flex items-center gap-2 mb-3">
        <FileText className="h-4 w-4 text-amber-700" />
        <h3 className="text-sm font-semibold text-amber-900">{title}</h3>
        <span className="text-xs text-amber-700/70">({drafts.length})</span>
      </div>
      <div className="space-y-1.5">
        {drafts.map((d) => (
          <div
            key={d.id}
            className={`flex items-center justify-between gap-2 px-3 py-2 rounded-md text-sm bg-white border ${
              d.id === currentDraftId ? 'border-amber-400 ring-1 ring-amber-200' : 'border-amber-100'
            }`}
            data-testid={`draft-row-${d.id}`}
          >
            <div className="flex-1 min-w-0">
              <div className="font-medium truncate">{d.label || 'Untitled draft'}</div>
              <div className="text-xs text-muted-foreground">Saved {fmtTime(d.updated_at)}</div>
            </div>
            <button
              type="button"
              onClick={() => onResume && onResume(d)}
              className="px-2.5 py-1 text-xs rounded-md bg-amber-600 text-white hover:bg-amber-700 flex items-center gap-1"
              data-testid={`draft-resume-${d.id}`}
            >
              <RotateCw className="h-3 w-3" /> Resume
            </button>
            <button
              type="button"
              onClick={() => {
                if (window.confirm('Delete this saved draft? This cannot be undone.')) {
                  onDelete && onDelete(d.id);
                }
              }}
              className="px-2 py-1 text-xs rounded-md text-red-600 hover:bg-red-50"
              data-testid={`draft-delete-${d.id}`}
              title="Delete draft"
            >
              <Trash2 className="h-3.5 w-3.5" />
            </button>
          </div>
        ))}
      </div>
    </div>
  );
};
